// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.YouMayAlsoNeed.View'
,   [
        'item_relations_cell.tpl',
        'item_relations_row.tpl',
        'facets_items_collection.tpl',
        'facets_items_collection_view_cell.tpl',
        'facets_items_collection_view_row.tpl',
        'c3_shoppingextensions_youmayalsoneed_items.tpl',
        'C3.ShoppingExtensions.YouMayAlsoNeed.CellView',
        'Tracker',
        'Utils',
        'C3.ShoppingExtensions.YouMayAlsoNeed.Collection',
        'Backbone.CollectionView',
        'Backbone'
    ]
, function (
    item_relations_cell_tpl,
    item_relations_row_tpl,
    facets_items_collection_tpl,
    facets_items_collection_view_cell_tpl,
    facets_items_collection_view_row_tpl,
    c3_shoppingextensions_youmayalsoneed_items_tpl,
   // facets_items_collection_view_cell_tpl,
   // facets_items_collection_view_row_tpl,
    //ItemRelationsRelatedItemView,
    C3ShoppingExtensionsYouMayAlsoNeedCellView,
    Tracker,
    Utils,
    C3ShoppingExtensionsYouMayAlsoNeedCollection,
    BackboneCollectionView,
    Backbone
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
    return BackboneCollectionView.extend({

        initialize: function (options) {

       this.slideWidth = options.slideWidth;
       this.maxSlides = options.maxSlides;
            
        const { siteSettings } = this.options.application.getConfig();
        const is_sca_advanced = siteSettings.sitetype === 'ADVANCED';
        const collection = is_sca_advanced
            ? new C3ShoppingExtensionsYouMayAlsoNeedCollection({ itemsIds: this.options.itemsIds,configuration : this.options.configuration})
            : new Backbone.Collection();

       // console.log(collection)
        

        var itemIdsLength = collection.itemsIds
         //console.log(itemIdsLength)   
        BackboneCollectionView.prototype.initialize.call(this, {
            collection: collection,
            viewsPerRow: Infinity,
            cellTemplate: item_relations_cell_tpl,
            rowTemplate: item_relations_row_tpl,
            childView: C3ShoppingExtensionsYouMayAlsoNeedCellView,
            template: c3_shoppingextensions_youmayalsoneed_items_tpl,
            childViewOptions: {
                    origin: 'You-May-Also-Like',
                    hideArrowsYouMayAlsoNeed : itemIdsLength.length <= 5 ? true : false,
                    application : this.options.application,
                    configuration : this.options.configuration,
                    container : this.options.container
                }
        });

        this.view_tracked = false;

        if (is_sca_advanced) {
            this.once('afterCompositeViewRender', this.loadRelatedItems, this);
        }
        },

        loadRelatedItems: function loadRelatedItems() {
        const self = this;

        self.collection.fetchItems().done(function() {
            if (self.collection.length) {
                if (!self.view_tracked) {
                    Tracker.getInstance().trackProductListEvent(
                        self.collection,
                        'You May Also Like Items'
                    );
                    self.view_tracked = true;
                }
            }

            self.render();

           // if(!Utils.isPhoneDevice())
           // {

            setTimeout(function() {
                const carousel = self.$el.find('[data-type="carousel-items"]');

                const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.options.application.getConfig();

                if (Utils.isPhoneDevice() === false && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }
                
                //bxSliderDefaults.slideWidth = 253;

                if(self.collection.length >= 6)
                {
                  bxSliderDefaults.controls = true;  
                  bxSliderDefaults.slideWidth = 252;
                }
                else{
                   bxSliderDefaults.slideWidth = 262;
                   bxSliderDefaults.controls = false;  


                }

                bxSliderDefaults.maxSlides = 5;
                //bxSliderDefaults.controls = true;
                bxSliderDefaults.hideControlOnEnd = true;
                bxSliderDefaults.prevText = '<a data-click="left-click" data-action="pdp-youmay-click" class="pdp-youmay carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
                bxSliderDefaults.nextText = '<a data-click="right-click" data-action="pdp-youmay-click" class="pdp-youmay carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
                /*bxSliderDefaults.prevText = '<a class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';
                bxSliderDefaults.nextText = '<a class="carousel-items-next-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
                *///bxSliderDefaults.touchEnabled = false;
               //console.log(bxSliderDefaults)
                bxSliderDefaults.infiniteLoop = false;
                Utils.initBxSlider(carousel, bxSliderDefaults);

                if(self.collection.length < 6)
                $('.you-may-also-need-section .bx-viewport').css('margin-left','0px')
            });
           // }
        });
    }

    });
});
